import { render, staticRenderFns } from "./TransactionSizeModify.vue?vue&type=template&id=90c3c944&"
import script from "./TransactionSizeModify.vue?vue&type=script&lang=js&"
export * from "./TransactionSizeModify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports